// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradne";
export const BAZAAR = "Baz\u00e1r";
export const BLOGS_WALL = "Pr\u00edspevky";
export const CONTESTS = "S\u00fa\u0165a\u017ee";
export const FORUMS_AND_GROUPS = "Diskusie a skupiny";
export const LOG_IN = "Prihl\u00e1s sa";
export const MAGAZINE = "Magaz\u00edn";
export const MAIN_MENU_REVIEWS = "Recenzie";
export const REGISTER_HERE = "Zaregistruj sa tu!";
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Modr\u00fd kon\u00edk \u2022 Skuto\u010dn\u00ed \u013eudia. Skuto\u010dn\u00fd \u017eivot. Re\u00e1lne sk\u00fasenosti.";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
